import { Box, Typography } from '@mui/material'
import theme from '../../../theme/theme'
import { useTranslation } from 'react-i18next'
import { IDefaultEntityData } from '../interfaces'
import DefaultEntitySelect from './DefaultEntitySelect'

interface ProductPreferencesProps {
    orgId: string
    productPreferences: IDefaultEntityData | null
    handleProductPreferenceChange: (value: IDefaultEntityData | null) => void
    disabled: boolean
}

const ProductPreferences = ({
    orgId,
    productPreferences,
    handleProductPreferenceChange,
    disabled,
}: ProductPreferencesProps): JSX.Element => {
    const { t } = useTranslation()

    const onChangeDefaltProduct = (
        id: string,
        value: IDefaultEntityData | null,
    ) => {
        handleProductPreferenceChange(value)
    }

    return (
        <Box>
            <Typography
                variant="h6"
                component="h2"
                sx={{
                    fontSize: theme.typography.h6,
                    textWrap: 'nowrap',
                    marginBottom: '15px',
                }}
            >
                {t('productPreferences')}
            </Typography>
            <Box
                sx={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(2, 1fr)',
                    gap: '20px',
                    alignItems: 'flex-start',
                }}
            >
                <DefaultEntitySelect
                    orgId={orgId}
                    value={productPreferences}
                    onChange={onChangeDefaltProduct}
                    label="defaultProduct"
                    entityTemplateName="Product"
                    disabled={disabled}
                />
            </Box>
        </Box>
    )
}

export default ProductPreferences
